module.exports = __webpack_public_path__ + "img/reviewed.6f682e52.svg";